import { CloseModalEvent, getModal } from "../../Shared/Modal/modal";
import { getRequiredElement } from "../../Shared/Utilities/attributes";

const modal = document.getElementById("webinar-modal");

if (modal) {
  const form = getRequiredElement(modal, "form");

  // Walk up to the outer [data-modal] container – that's where modal:close is dispatched.
  const container = modal.closest<HTMLElement>("[data-modal]");

  container?.addEventListener("modal:close", (e: Event) => {
    const closeEvent = e as CloseModalEvent;

    // Only navigate when the close was user-initiated (close button, backdrop, Escape).
    // Programmatic closes (e.g. after form submission) have no originalEvent.
    if (!closeEvent.detail.originalEvent) {
      return;
    }

    const backUrl = container.dataset.backUrl;

    // If the visitor arrived via normal in-site navigation use the browser history so they
    // land back on exactly the page they came from. Otherwise (direct link, new tab, email,
    // etc.) fall back to the webinar list page URL resolved server-side.
    const hasSameOriginReferrer =
      document.referrer !== "" &&
      new URL(document.referrer).origin === window.location.origin;

    if (hasSameOriginReferrer) {
      history.back();
    } else if (backUrl) {
      window.location.href = backUrl;
    }
  });

  if (window.$$epiforms) {
    window.$$epiforms(document).ready(function () {
      window
        .$$epiforms?.(".EPiServerForms")
        .on("formsSubmitted", function (event: Event) {
          if (form === event.currentTarget) {
            setTimeout(() => {
              const modalDefinition = getModal(modal);

              // Close modal after successful form submission
              modalDefinition?.close();
            }, 1500);
          }
        });
    });
  } else {
    console.error(
      "EPiServer Forms library not found. Webinar form functionality may be broken."
    );
  }
}
